import React, { useEffect, useRef, useState } from 'react'
import { getApiCall, postApiCall } from '../../utils/api';
import MaterialTable from 'material-table';
import tableIcons from '../component/MaterialIcon';
import { ThemeProvider, createTheme } from '@mui/material';
import { Delete, Edit } from '@material-ui/icons';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import Loader from '../../components/spinner/Loader';
import { CircleSpinnerOverlay } from 'react-spinner-overlay';

const classCodeList = [
    { "id": 1 },
    { "id": 2 },
    { "id": 3 },
    { "id": 4 },
    { "id": 5 },
    { "id": 6 },
    { "id": 7 },
    { "id": 8 },
    { "id": 9 },
    { "id": 10 },
    { "id": 11 },
    { "id": 12 },
]

const Classes = () => {

    const defaultMaterialTheme = createTheme();
    const [selectedRow, setSelectedRow] = useState(null);
    const inputRef = useRef(null);
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [streamList, setStreamList] = useState([])
    const [boardList, setBoardList] = useState([])
    const [mediumList, setMediumList] = useState([])
    const [className, setClassName] = useState("")
    const [streamName, setStreamName] = useState("")
    const [scriptName, setScriptName] = useState("")
    const [classCode, setClassCode] = useState("")

    const [boardName, setBoardName] = useState("")
    const [mediumName, setMediumName] = useState("")

    const [classID, setClassID] = useState("")

    useEffect(() => {
        fetchData()
    }, [])
    const fetchData = async () => {
        setLoading(true)

        const boardRes = await getApiCall("board/get/all")
        setBoardList(boardRes.data);

        const res = await getApiCall("class/get/all")
        setData(res.data);
        if (res.data.length !== 0 || res.data !== null) {
            res.data.forEach((data, index) => { data.serial = index + 1; });
        }
        setLoading(false)

    }

    const onBoardChange = async (val) => {
        setLoading(true)
        const mediumRes = await postApiCall("language/get/byBoard", { "id": val })
        setMediumList(mediumRes.data);

        const streamRes = await postApiCall("stream/get/byBoard", { "id": val })
        setStreamList(streamRes.data);

        setLoading(false)
    }

    const handleSubmit = async () => {
        setLoading(true)

        if (className === "" || classCode === "" || scriptName === "" || boardName === "" || mediumName === "")
            return Swal.fire({
                title: 'Error',
                text: 'Please enter the necessary field',
                icon: 'error'
            });

        let res = {}
        if (classID === "") {
            res = await postApiCall("class/add", { "stream_id": streamName, "name": className, "class_code": classCode, "script": scriptName, "board_id": boardName, "medium_id": mediumName })
        } else {
            res = await postApiCall("class/update", { "id": classID, "stream_id": streamName, "name": className, "class_code": classCode, "script": scriptName, "board_id": boardName, "medium_id": mediumName })
        }
        setLoading(false)
        if (res.error === true) {
            return Swal.fire({
                title: 'Error',
                text: res.message,
                icon: 'error'
            });
        }
        Swal.fire({
            title: 'Successful',
            text: res.message,
            icon: 'success'
        });
        setClassName("")
        setClassID("")
        // setStreamName("")
        setClassCode("")
        setScriptName("")
        // setBoardName("")
        // setMediumName("")
        fetchData()
    }

    const columns = [
        { title: "Sl. no", field: "serial" },
        { title: "Class", field: "name" },
        { title: "Class Code", field: "class_code" },
        { title: "Script", field: "script" },
        { title: "Board", field: "board_name" },
        { title: "Medium", field: "language_name" },
        {
            title: "Stream", field: "streamData",
            render: rowData => {
                return (
                    <>
                        {rowData.streamData === null ? "" : rowData.streamData.name}
                    </>
                )
            }
        },
    ]

    const handleEdit = async (rowData) => {
        setClassName(rowData.name)
        setBoardName(rowData.board_id)
        setScriptName(rowData.script)
        setClassCode(rowData.class_code)
        setClassID(rowData.id)
        setStreamName(rowData.stream_id)
        setMediumName(rowData.language_id)

        onBoardChange(rowData.board_id)

        inputRef.current.focus();
        const input = document.getElementById('classInput');
        input.classList.add('glow');
        input.focus();
        setTimeout(() => {
            input.classList.remove('glow');
        }, 1000);
    }

    const handleDelete = async (rowData) => {
        new Swal({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const res = await postApiCall("class/delete", { "id": rowData.id })
                if (res.error === true) {
                    return Swal.fire({
                        title: 'Error',
                        text: res.message,
                        icon: 'error'
                    });
                }
                Swal.fire({
                    title: 'Successful',
                    text: res.message,
                    icon: 'success'
                });
                fetchData()
            }
        })

    }

    return (
        <div>
            <CircleSpinnerOverlay
                loading={loading}
                overlayColor="rgba(0,153,255,0.2)"
            />
            <div className='content-wrapper'>

                <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h4 className="m-0">Class</h4>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active">Class</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            {/* left column */}
                            <div className="col-md-12 mt-4">
                                {/* general form elements */}
                                <div className="card card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title">{classID === "" ? "Add" : "Edit"} class</h3>
                                    </div>
                                    {/* /.card-header */}
                                    {/* form start */}
                                    {/* <form> */}
                                    <div className="card-body">
                                        <div className="row">

                                            <div className="col-md-4 col-sm-12">
                                                <div class="form-group">
                                                    <label for="selectInput">{classID === "" ? "Select" : "Edit"} Board</label>
                                                    <select
                                                        class="custom-select form-select rounded-0"
                                                        id="selectInput"
                                                        onChange={(e) => {
                                                            setBoardName(e.target.value)
                                                            setMediumName("")
                                                            onBoardChange(e.target.value)
                                                        }}
                                                        required
                                                        value={boardName}
                                                    >
                                                        <option value="" disabled selected>
                                                            Select an option
                                                        </option>
                                                        {boardList.map((option) => (
                                                            <option key={option.id} value={option.id}>
                                                                {option.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-4 col-sm-12">
                                                <div class="form-group">
                                                    <label for="selectInput">{classID === "" ? "Select" : "Edit"} Medium</label>
                                                    <select
                                                        class="custom-select form-select rounded-0"
                                                        id="selectInput"
                                                        onChange={(e) => setMediumName(e.target.value)}
                                                        required
                                                        value={mediumName}
                                                    >
                                                        <option value="" disabled selected>
                                                            Select an option
                                                        </option>
                                                        {mediumList.map((option) => (
                                                            <option key={option.id} value={option.id}>
                                                                {option.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-4 col-sm-12">
                                                <div className="form-group">
                                                    <label htmlFor="classInput">{classID === "" ? "Add" : "Edit"} Class</label>
                                                    <input
                                                        type="text"
                                                        onChange={(e) => setClassName(e.target.value)}
                                                        className="form-control"
                                                        id="classInput"
                                                        placeholder="Enter Class"
                                                        value={className}
                                                        ref={inputRef}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4 col-sm-12">
                                                <div className="form-group">
                                                    <label htmlFor="classInput">{classID === "" ? "Add" : "Edit"} Script</label>
                                                    <input
                                                        type="text"
                                                        onChange={(e) => setScriptName(e.target.value)}
                                                        className="form-control"
                                                        id="classInput"
                                                        placeholder="Enter Script"
                                                        value={scriptName}
                                                        ref={inputRef}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4 col-sm-12">
                                                <div class="form-group">
                                                    <label for="selectInput">{classID === "" ? "Select" : "Edit"} Class Code</label>
                                                    <select
                                                        class="custom-select form-select rounded-0"
                                                        id="selectInput"
                                                        onChange={(e) => setClassCode(e.target.value)}
                                                        required
                                                        value={classCode}
                                                    >
                                                        <option value="" disabled selected>
                                                            Select an option
                                                        </option>
                                                        {classCodeList.map((option) => (
                                                            <option key={option.id} value={option.id}>
                                                                {option.id}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-4 col-sm-12">
                                                <div class="form-group">
                                                    <label for="selectInput">{classID === "" ? "Select" : "Edit"} Stream</label>
                                                    <select
                                                        class="custom-select form-select rounded-0"
                                                        id="selectInput"
                                                        onChange={(e) => setStreamName(e.target.value)}
                                                        required
                                                        value={streamName}
                                                    >
                                                        <option value="" disabled selected>
                                                            Select an option
                                                        </option>
                                                        <option value="">Clear all&times;</option>
                                                        <option value="" disabled>
                                                            --------------------
                                                        </option>

                                                        {streamList.map((option) => (
                                                            <option key={option.id} value={option.id}>
                                                                {option.name}
                                                            </option>
                                                        ))}
                                                    </select>

                                                </div>
                                            </div>

                                        </div>


                                    </div>
                                    <div className="card-footer">
                                        <button type="submit" onClick={() => handleSubmit()} className="btn btn-primary">{classID === "" ? "Submit" : "Update"}</button>
                                    </div>
                                </div>
                                {/* /.card-body */}

                                {/* </form> */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/*/.col (right) */}
                    </div>
                    {/* /.row */}
                </section >


                <section className="content mt-4">
                    <div className="container-fluid">
                        <ThemeProvider theme={defaultMaterialTheme}>
                            <MaterialTable
                                icons={tableIcons}
                                title="Classes"
                                columns={columns}
                                data={data}
                                onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
                                options={{
                                    exportButton: true,
                                    actionsColumnIndex: -1,
                                    headerStyle: {
                                        backgroundColor: 'rgb(0 123 255)',
                                        color: '#FFF',
                                        fontSize: 18
                                    },
                                    rowStyle: (rowData, index) => ({
                                        backgroundColor: (selectedRow === rowData.tableData.id) ? '#d3d4d1' : index % 2 !== 0 ? '#EEE' : '#FFF'
                                    }),
                                }}
                                actions={[
                                    {
                                        icon: () => <span style={{ color: '#5656ce' }}><Edit /></span>,
                                        tooltip: 'Edit',
                                        onClick: (event, rowData) => handleEdit(rowData),
                                    },
                                    // rowData => ({
                                    //     icon: () => <span style={{ color: '#5656ce' }}><Delete /></span>,
                                    //     tooltip: 'Delete',
                                    //     onClick: (event, rowData) => handleDelete(rowData),
                                    // })
                                ]}
                            />
                        </ThemeProvider>
                    </div>
                </section>

            </div>
        </div>
    )
}

export default Classes